/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_Eleven_LabsInputs */

const en_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs`)
};

const fr_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs`)
};

const de_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs`)
};

const it_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs`)
};

const ru_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs`)
};

const es_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OnceLabs`)
};

const zh_cn2_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ElevenLabs`)
};

const ja_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イレブンラボ`)
};

const hi_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इलेवनलैब्स`)
};

const pt_pt2_voice_manager_provider_eleven_labs = /** @type {(inputs: Voice_Manager_Provider_Eleven_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OnzeLabs`)
};

/**
* | output |
* | --- |
* | "ElevenLabs" |
*
* @param {Voice_Manager_Provider_Eleven_LabsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_eleven_labs = /** @type {((inputs?: Voice_Manager_Provider_Eleven_LabsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_Eleven_LabsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_eleven_labs(inputs)
	if (locale === "de") return de_voice_manager_provider_eleven_labs(inputs)
	if (locale === "it") return it_voice_manager_provider_eleven_labs(inputs)
	if (locale === "ru") return ru_voice_manager_provider_eleven_labs(inputs)
	if (locale === "es") return es_voice_manager_provider_eleven_labs(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_eleven_labs(inputs)
	if (locale === "ja") return ja_voice_manager_provider_eleven_labs(inputs)
	if (locale === "hi") return hi_voice_manager_provider_eleven_labs(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_eleven_labs(inputs)
	return en_voice_manager_provider_eleven_labs(inputs)
});